const PRIORITY_BRANDS = [
  "POPRACE",
  "MINIGT",
  "INNO64",
  "TARMAC WORKS",
  "BMC",
  "HOT WHEELS",
];

const normalizeBrandName = (value = "") =>
  String(value).toUpperCase().replace(/[^A-Z0-9]/g, "");

const priorityIndexMap = new Map(
  PRIORITY_BRANDS.map((brand, index) => [normalizeBrandName(brand), index])
);

const getBrandPriorityIndex = (brand = {}) => {
  const label = brand.name ?? brand.label ?? "";
  const normalized = normalizeBrandName(label);
  return priorityIndexMap.has(normalized)
    ? priorityIndexMap.get(normalized)
    : Number.POSITIVE_INFINITY;
};

const getBrandSortLabel = (brand = {}) =>
  String(brand.name ?? brand.label ?? "").trim().toUpperCase();

export const sortBrandsForDisplay = (brands = []) =>
  [...brands].sort((a, b) => {
    const aPriority = getBrandPriorityIndex(a);
    const bPriority = getBrandPriorityIndex(b);

    if (aPriority !== bPriority) {
      return aPriority - bPriority;
    }

    return getBrandSortLabel(a).localeCompare(getBrandSortLabel(b));
  });
